var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("h" + (_vm.box.data.level)),_vm._b({tag:"component",class:_vm.css.boxHeading,domProps:{"innerHTML":_vm._s(_vm.parseLinksInString(_vm.box.data.text))}},'component',_vm.schemaDisabled ? '': {
    itemprop: 'articleBody',
  },false))}
var staticRenderFns = []

export { render, staticRenderFns }